import React from 'react';
import HttpStatusPage from 'app/components/pages/HttpStatusPage';
import { useI18n } from 'app/components/localization';

export const Forbidden: React.FC = () => {
  const { t } = useI18n();
  return (
    <HttpStatusPage
      status={403}
      header={t('http-status-page.403.header')}
      message={t('http-status-page.403.message')}
    />
  );
};

export default Forbidden;
